import React, { useEffect, useState } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { Card, Table, Button, Form, Badge } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import Pagination from 'react-js-pagination';
import { DANGKYDUTUYEN_API, DOTTUYENSINH_API } from '@app/utils/apiUrl';
import { DeleteSingle, Get } from '@app/utils/httpProvider';
import { createUrlWithParam } from '../../../../utils/helper';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import { messageToast, objectShowNumber, status200, styleSelectDefault, objectTrangThaiDangKyDuTuyen, trangThaiDangKyDuTuyenValue } from '../../../../utils/define';
import { ConfirmModal } from '../../../../modules/modal/ConfirmModal';
import { AsyncPaginate } from 'react-select-async-paginate';
import moment from 'moment';

const DangKyDuTuyen = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');
    const [dotTuyenSinhId, setDotTuyenSinhId] = useState(null);
    const [trangThaiDangKyDuTuyen, setTrangThaiDangKyDuTuyen] = useState(trangThaiDangKyDuTuyenValue.all);

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (paramUrl.get('page') != null && parseInt(paramUrl.get('page'), 10) !== page) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (paramUrl.get('size') != null && parseInt(paramUrl.get('size'), 10) !== pageSize) {
        setPageSize(parseInt(paramUrl.get('size'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    const replaceHistory = (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.DANGKYDUTUYEN_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['dangKyDuTuyenData', valueSearch, page, pageSize, dotTuyenSinhId, trangThaiDangKyDuTuyen],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize,
                DotTuyenSinhId: dotTuyenSinhId || '',
                TrangThaiDangKyDuTuyen: trangThaiDangKyDuTuyen !== trangThaiDangKyDuTuyenValue.all ? trangThaiDangKyDuTuyen : null
            };
            replaceHistory(page, pageSize, valueSearch);
            return Get(DANGKYDUTUYEN_API.GET_PAGING, null, model);
        },
        {
            keepPreviousData: true
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page, dotTuyenSinhId, trangThaiDangKyDuTuyen]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            setPage(1);
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search);
    };

    const deleteFunc = useMutation((value) => DeleteSingle(DANGKYDUTUYEN_API.DELETE_ITEM, value, null));

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = () => {
        if (!idWantDelete) return;

        deleteFunc.mutate(idWantDelete, {
            onSuccess: (res) => {
                if (res.status === status200 || res.status === 201) {
                    toast.success(messageToast.messageToastDeleteSuccess);
                    refetch();
                } else {
                    toast.error(messageToast.messageToastDeleteError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || messageToast.messageToastTryCatch);
            }
        });

        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    const getTrangThaiBadge = (status) => {
        const statusObj = objectTrangThaiDangKyDuTuyen.find(s => s.value === status);
        if (!statusObj) return <Badge variant="secondary">Không xác định</Badge>;

        let variant = 'secondary';
        switch (status) {
            case trangThaiDangKyDuTuyenValue.moiDangKy:
                variant = 'info';
                break;
            case trangThaiDangKyDuTuyenValue.daTiepNhan:
            case trangThaiDangKyDuTuyenValue.daCapTaiKhoan:
            case trangThaiDangKyDuTuyenValue.daTaoHoSo:
                variant = 'success';
                break;
            case trangThaiDangKyDuTuyenValue.tuChoi:
            case trangThaiDangKyDuTuyenValue.huy:
                variant = 'danger';
                break;
            default:
                variant = 'warning';
        }

        return <Badge variant={variant}>{statusObj.label}</Badge>;
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    const loadOptionsDotTuyenSinh = async (search, loadedOptions, { page }) => {
        const pageSize = 10;
        const res = await Get(DOTTUYENSINH_API.GET_PAGING, null, {
            PageIndex: page,
            PageSize: pageSize,
            Keyword: search // pass the input text to filter server-side
        });

        const data = res.data || [];
        const options = data.map((x) => ({
            label: `${x.maDot} - ${x.tenDot}`,
            value: x.id
        }));

        // assume your API returns total count or a flag for more pages
        const hasMore = data.length === pageSize;
        return {
            options,
            hasMore,
            additional: { page: page + 1 }
        };
    };

    return (
        <div className="container-fluid">
            <Card>
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <h5>Danh sách đăng ký dự tuyển</h5>
                        <div className="d-flex">
                            <NavLink to={URI_INTERNAL.DANGKYDUTUYEN_CREATE_PATH} className="btn btn-success">
                                Thêm mới
                            </NavLink>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="row mb-3">
                        <div className="col-md-3">
                            <AsyncPaginate
                                name="dotTuyenSinhId"
                                id="dotTuyenSinhId"
                                placeholder="Chọn đợt tuyển sinh"
                                value={dotTuyenSinhId?.value}
                                loadOptions={loadOptionsDotTuyenSinh}
                                styles={styleSelectDefault}
                                isClearable
                                onChange={(selectedOption) => {
                                    setDotTuyenSinhId(selectedOption?.value || null);
                                }}
                                additional={{
                                    page: 1
                                }}
                            />
                        </div>
                        <div className="col-md-3">
                            <Form.Control
                                as="select"
                                value={trangThaiDangKyDuTuyen}
                                onChange={(e) => setTrangThaiDangKyDuTuyen(e.target.value)}
                            >
                                {objectTrangThaiDangKyDuTuyen.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </option>
                                ))}
                            </Form.Control>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>STT</th>
                                    <th>Họ tên</th>
                                    <th>Ngày sinh</th>
                                    <th>Giới tính</th>
                                    <th>CCCD</th>
                                    <th>Email</th>
                                    <th>Điện thoại</th>
                                    <th>Đợt tuyển sinh</th>
                                    <th>Trạng thái</th>
                                    <th>Ngày đăng ký</th>
                                    <th>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={11}>Đang tải...</td>
                                    </tr>
                                ) : isError ? (
                                    <tr>
                                        <td colSpan={11}>Lỗi: {error?.message || 'Không tải được dữ liệu'}</td>
                                    </tr>
                                ) : items.length === 0 ? (
                                    <tr>
                                        <td colSpan={11}>Không có dữ liệu</td>
                                    </tr>
                                ) : (
                                    items.map((item, index) => (
                                        <tr key={item.id || index}>
                                            <td>{(page - 1) * pageSize + index + 1}</td>
                                            <td>{item.hoTen || item.HoTen}</td>
                                            <td>{item.ngaySinh ? moment(item.ngaySinh).format('DD/MM/YYYY') : '-'}</td>
                                            <td>
                                                {item.gioiTinh === 0 ? 'Nam' :
                                                    item.gioiTinh === 1 ? 'Nữ' : '-'}
                                            </td>
                                            <td>{item.cccd || item.CCCD || item.canCuocCongDan}</td>
                                            <td>{item.email || item.Email}</td>
                                            <td>{item.dienThoai || item.DienThoai}</td>
                                            <td>{item.tenDotTuyenSinh || item.TenDotTuyenSinh}</td>
                                            <td>{getTrangThaiBadge(item.trangThaiDangKyDuTuyen)}</td>
                                            <td>{item.ngayDangKy ? moment(item.ngayDangKy).format('DD/MM/YYYY HH:mm') : '-'}</td>
                                            <td>
                                                <NavLink
                                                    className="btn btn-primary btn-sm mr-2"
                                                    to={`${URI_INTERNAL.DANGKYDUTUYEN_EDIT_PATH}?id=${item.id}`}>
                                                    Sửa
                                                </NavLink>
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={() => deleteAction(item.id, item.hoTen || item.HoTen)}>
                                                    Xóa
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div>
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                innerClass="pagination pagination-sm no-margin"
                                activePage={page}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                            />
                        </div>
                    </div>

                    <ConfirmModal
                        isOpen={openConfirmDeleteModal}
                        confirmType="delete"
                        handleAccept={acceptDelete}
                        handleCancel={cancelDelete}
                        content={confirmDelMessage}
                    />
                </Card.Body>
            </Card>
        </div>
    );
};

export default DangKyDuTuyen;